/**
 * DEVELOPMENT
 * * @type {string}
 */
var SITE_URL = "https://dv.test.we-change.ru";
var API_URL = "https://api.dv.test.we-change.ru";
var ATTACH_SERVER = "https://attach.test.we-change.ru";
var USER_SERVICE_URL = "https://user.test.we-change.ru";
var AUTH_LINK = USER_SERVICE_URL + "/authorize?response_type=token&client_id=9&state=k89f98DFc3612&scope=everything&redirect_uri=http://localhost:8080/";
var REG_LINK = USER_SERVICE_URL + "/register?response_type=token&client_id=9&state=k89f98DFc3612&scope=everything&redirect_uri=http://localhost:8080/search";
var LOGOUT_LINK = USER_SERVICE_URL + "/logout";
/**
 * PRODUCTION
 */
if (process.env.BUILD_ENV === "production") {
    SITE_URL = "https://dv2025.ru";
    API_URL = "https://api.dv2025.ru";
    ATTACH_SERVER = "https://attach.test.we-change.ru";
    USER_SERVICE_URL = "https://user.we-change.ru";
    AUTH_LINK = USER_SERVICE_URL + "/authorize?response_type=token&client_id=9&state=k89f98DFc3612&scope=everything&redirect_uri=https://dv.test.we-change.ru/";
    REG_LINK = USER_SERVICE_URL + "/register?response_type=token&client_id=9&state=k89f98DFc3612&scope=everything&redirect_uri=https://dv.test.we-change.ru/search";
    LOGOUT_LINK = USER_SERVICE_URL + "/logout";
}
else if (process.env.BUILD_ENV === "preproduction") {
    /**
     * PREPRODUCTION
     * * @type {string}
     */
    SITE_URL = "https://dv.test.we-change.ru";
    API_URL = "https://api.dv.test.we-change.ru";
    ATTACH_SERVER = "https://attach.test.we-change.ru";
    USER_SERVICE_URL = "https://user.test.we-change.ru";
    AUTH_LINK = USER_SERVICE_URL + "/authorize?response_type=token&client_id=9&state=k89f98DFc3612&scope=everything&redirect_uri=https://dv.test.we-change.ru/";
    REG_LINK = USER_SERVICE_URL + "/register?response_type=token&client_id=9&state=k89f98DFc3612&scope=everything&redirect_uri=https://dv.test.we-change.ru/search";
    LOGOUT_LINK = USER_SERVICE_URL + "/logout";
}
export { API_URL, ATTACH_SERVER, AUTH_LINK, REG_LINK, LOGOUT_LINK, USER_SERVICE_URL, SITE_URL, };



//////////////////
// WEBPACK FOOTER
// ./src/config/urls.ts
// module id = 5
// module chunks = 0